import React, { useState, useEffect, useCallback } from 'react';
import cx from 'classnames';
import { Button, FormGroup } from 'reactstrap';
import { Icon } from 'js/components';
import { Checkbox } from 'js/components/Forms/Checkbox';
import TextareaAutosize from 'react-textarea-autosize';
import styles from './CustomizeAssessment.module.scss';

export function NotificationOption({
  type,
  icon,
  label,
  config,
  onSelectedChange,
  onCustomMessageToggle,
  onMessageChange,
}) {
  const [message, setMessage] = useState(null);

  const handleMessageBlur = () => {
    onMessageChange(type, message);
  };

  const handleCustomMessageToggle = useCallback(() => {
    onCustomMessageToggle(type, !config?.useCustomMessage);
  }, [onCustomMessageToggle, type, config?.useCustomMessage]);

  const handleSelectedChange = useCallback(
    (e) => {
      onSelectedChange(type, e.target.checked);
    },
    [onSelectedChange, type]
  );

  useEffect(() => {
    if (message == null && config?.message != null) {
      setMessage(config.message);
    }
  }, [config?.message, message]);

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  return (
    <div className={styles['notify-option']}>
      <Checkbox checked={!!config?.enabled} onChange={handleSelectedChange}>
        <span className={styles['notify-option-icon']}>
          <Icon icon={icon} className="icon-left" />
        </span>
        <span className={styles['notify-option-label']}>{label}</span>
      </Checkbox>
      <span className={styles['notify-option-customize']}>
        {config?.useCustomMessage ? (
          <FormGroup>
            <TextareaAutosize
              value={message ?? ''}
              onChange={handleMessageChange}
              onBlur={handleMessageBlur}
              placeholder="Enter your custom message..."
              className={cx(styles['message-textarea'], 'form-control')}
            />
            <Button color="link" size="sm" onClick={handleCustomMessageToggle}>
              Remove custom message
            </Button>
          </FormGroup>
        ) : (
          <Button color="link" size="sm" onClick={handleCustomMessageToggle}>
            Customize message
          </Button>
        )}
      </span>
    </div>
  );
}

export default NotificationOption;
